/* unplugin-vue-components disabled */import script from "./HomeVoices.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeVoices.vue?vue&type=script&setup=true&lang=js"

import "./HomeVoices.vue?vue&type=style&index=0&id=1c071a46&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/e652ddcf-2c47-4325-b31c-639f40aeccc9/workspace/mobile-FTZCOIN_ILBL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c071a46"]])

export default __exports__